var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGps(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "search-icon",
    width: 21,
    height: 22,
    viewBox: "0 0 21 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.413 2.9L2.132 9.226L6.961 11.232C8.37252 11.8175 9.49395 12.9393 10.079 14.351L12.085 19.179L18.413 2.9ZM20.26 3.582L13.932 19.863C13.532 20.893 12.381 21.42 11.361 21.043C11.1125 20.9512 10.8856 20.8091 10.6946 20.6254C10.5035 20.4418 10.3525 20.2207 10.251 19.976L8.244 15.146C7.85357 14.2053 7.10586 13.458 6.165 13.068L1.337 11.062C0.332999 10.645 -0.125001 9.486 0.313999 8.472C0.421849 8.22414 0.577652 8.00006 0.772442 7.81265C0.967231 7.62524 1.19716 7.4782 1.449 7.38L17.73 1.052C18.0837 0.909859 18.4713 0.874778 18.8448 0.951117C19.2183 1.02746 19.5611 1.21185 19.8306 1.48139C20.1001 1.75093 20.2845 2.09373 20.3609 2.46719C20.4372 2.84065 20.4021 3.22831 20.26 3.582Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGps);
export default __webpack_public_path__ + "static/media/gps.f7927543.svg";
export { ForwardRef as ReactComponent };